/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    height: '100%',
    overflowY: 'auto'
  },
  loader: {
    textAlign: "center",
    alignItems: "center",
    padding: Tokens.spacing['$sp-3']
  },
  textInput: {
    display: 'flex',
    alignItems: 'baseline'
  },
  input: {
    width: theme.spacing(10),
    marginRight: Tokens.spacing['$sp-1-25'],
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  },
  realmSettings: {

  },
  message: {
    marginTop: Tokens.spacing['$sp-2']
  },
  alertMsg: {
    display: 'flex',
    alignItems: 'center',
    margin: Tokens.spacing['$sp-0'],
    padding: Tokens.spacing['$sp-2'],
    borderRadius: Tokens.spacing['$sp-1-25'],
    color: theme.palette.text.primary,
    backgroundColor: Palette.colors.orange['50'],
    border: `1px solid ${theme.palette.warning.main}`,
  },
  warningIcon: {
    marginRight: 10,
    color: theme.palette.warning.main,
  },
  passwordPolicyDisplayValue: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  passwordPolicyPopover: {
    overflow: 'auto',
    padding: Tokens.spacing['$sp-4'],
    maxWidth: Tokens.spacing['$sp-100'],
    maxHeight: Tokens.spacing['$sp-100'],
  },
  pointer: {
    fontWeight: 500
  },
}));
